import { Component } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { AuthenticationService } from 'src/app/services';

@Component({
  selector: 'app-sem-autorizacoes',
  templateUrl: './sem-autorizacoes.component.html',
  styleUrls: ['./sem-autorizacoes.component.scss']
})
export class SemAutorizacoesComponent {
  options: AnimationOptions = {
    path: '/assets/animations/alert.json'
  };
  animationCreated(animationItem: AnimationItem): void {}
  constructor(private authenticationService: AuthenticationService) {}

  sair() {
    this.authenticationService.logoutUsuario();
  }
}
